import { Card, Input, Button, Tooltip, Select, Space } from "antd";
import { FaSearch, FaChartLine, FaTimes } from "react-icons/fa";
import ExportParticipantesExcel from "./ExportParticipantesExcel";

const { Option } = Select;

export function ParticipantesFilter({
  searchTerm,
  setSearchTerm,
  filterEstado,
  setFilterEstado,
  filterSexo,
  setFilterSexo,
  filterDepartamento,
  setFilterDepartamento,
  filterMunicipio,
  setFilterMunicipio,
  estadosBackend,
  departamentos,
  municipios,
  showCharts,
  setShowCharts,
  permissionInsert,
  handleCreate,
  hasActiveFilters,
  onClearFilters,
  promotores,
  promotoresId,
  setPromotoresId,
  loadingPromotores,
  isAdmin,
  isRol2,
  isRol3,
  getAllParticipantsForExport
}) {

  return (
    <Card className="mb-6" style={{ borderRadius: 12, marginTop: 10 }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: 12,
          alignItems: "center",
          width: "100%"
        }}
      >

        <div style={{ width: "100%" }}>
          <Input
            prefix={<FaSearch style={{ fontSize: "17px" }} />}
            placeholder="Buscar por nombre o cc"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: 10,
              width: "100%",
              minWidth: "100%"
            }}
          />
        </div>
        <div style={{ width: "100%" }}>
          <Select
            value={filterEstado}
            onChange={setFilterEstado}
            style={{
              width: "100%",
              height: 45
            }}
            placeholder="Estado"
          >
            <Option value="todos">Estados</Option>
            {estadosBackend?.map((est, index) => {
              const key = est.id || `estado-${index}`;
              const valor = est.codigo;
              const label = est.nombre;
              return (
                <Option key={key} value={valor}>
                  {label}
                </Option>
              );
            })}
          </Select>
        </div>
        {isAdmin && (
          <div style={{ width: "100%" }}>
            <Select
              value={filterDepartamento}
              onChange={(value) => {
                setFilterDepartamento(value);
                setFilterMunicipio("todos");
                setPromotoresId(null);
              }}
              disabled={!isAdmin}
              style={{
                width: "100%",
                height: 45
              }}
              placeholder="Departamento"
            >
              <Option value="todos">Departamentos</Option>
              {departamentos?.map((depto, index) => {
                const key = depto.oid || `depto-${index}`;
                const valor = depto.oid;
                const label = depto.departamento;
                return (
                  <Option key={key} value={valor}>
                    {label}
                  </Option>
                );
              })}
            </Select>
          </div>)}
        {isAdmin && (
          <div style={{ width: "100%" }}>
            <Select
              value={filterMunicipio}
              onChange={(value) => {
                setFilterMunicipio(value);
                setPromotoresId(null);
              }}
              style={{
                width: "100%",
                height: 45
              }}
              placeholder="Municipio"
              disabled={!filterDepartamento || filterDepartamento === "todos" || !isAdmin}
            >
              <Option value="todos">Municipios</Option>
              {municipios?.map((mun, index) => {
                const key = mun.oid || mun.id || `mun-${index}`;
                const valor = mun.oid || mun.id;
                const label = mun.municipio || mun.nombre;
                return (
                  <Option key={key} value={valor}>
                    {label}
                  </Option>
                );
              })}
            </Select>
          </div>
        )}
        {!isRol3 && (
          <div style={{ width: "100%" }}>
            <Select
              value={promotoresId ?? undefined}

              onChange={setPromotoresId}
              style={{ width: "100%", height: 45 }}
              placeholder="Encuestadores"
              loading={loadingPromotores}
              disabled={
                isAdmin
                  ? (!filterMunicipio || filterMunicipio === "todos")
                  : false
              }
              allowClear
            >
              {Array.isArray(promotores) &&
                promotores.map((p, index) => (
                  <Option key={p.oid || index} value={p.oid}>
                    {`${p.nombres} ${p.apellidos}`}
                  </Option>
                ))
              }
            </Select>
          </div>
        )}

        <div style={{ width: "100%" }}>
          <Select
            value={filterSexo}
            onChange={setFilterSexo}
            style={{
              width: "100%",
              height: 45
            }}
            placeholder="Género"
          >
            <Option value="todos">Géneros</Option>
            <Option value="M">Masculino</Option>
            <Option value="F">Femenino</Option>
          </Select>
        </div>

        <Space>
          <Tooltip title="Mostrar / Ocultar Gráficas">
            <Button
              icon={<FaChartLine />}
              onClick={() => setShowCharts(!showCharts)}
              style={{
                borderColor: "#0968C6",
                color: "#0968C6",
                height: 45,
                whiteSpace: "nowrap",
                width: "auto"
              }}
            >
              {showCharts ? "Ocultar" : "Mostrar"}
            </Button>
          </Tooltip>

          {hasActiveFilters && (
            <Tooltip title="Limpiar filtros">
              <Button
                icon={<FaTimes />}
                onClick={onClearFilters}
                style={{
                  borderColor: "#ff4d4f",
                  color: "#ff4d4f",
                  height: 45,
                  whiteSpace: "nowrap",
                  width: "auto"
                }}
              >
                Limpiar
              </Button>
            </Tooltip>
          )}
        </Space>
        {(isAdmin || isRol2) && (
          <ExportParticipantesExcel getData={getAllParticipantsForExport} />
        )}
      </div>
    </Card>
  );
}